import { ListViewWrapper } from '@ami/react/core';
import FilterComponent from '../dealer-users/components/DealerUserFilterComponent';
import Table from '../dealer-users/components/DealerUserTable';
import { DealerUserFilter } from '../dealer-users/dealerUserFilter';
import { dealerUserService } from '../dealer-users/dealerUserService';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { CreateButton, TableActions } from '@ami/react/core';
import { pagination } from '@ami/react/core';
import { getGenericData, saveGenericData } from '@ami/react/core';
import { Modal } from '@ami/react/core';
import { isAmiUserAuthorizedToSendBulkInvitations } from '../authorization/amiPermissions';
import { Button } from '@ami/react/core';
import { NotificationManager } from 'react-notifications';
import { downloadWithFallback } from '@ami/react/core';
import DealerUserSimpleTable from '../dealer-users/components/DealerUserSimpleTable';

const SendInvitationsConfirmationModal = ({
  show,
  onShowUpdated,
  onConfirm,
  usersCount,
}) => (
  <Modal
    title="Send Invitations"
    show={show}
    onShowUpdated={onShowUpdated}
    okTitle="Yes"
    cancelTitle="No"
    onOk={onConfirm}
    showCancel={true}
  >
    <p>
      This action will send invitations to {usersCount} Dealer Users who have
      never previously received an invitation email.
    </p>
    <p>Are you sure you want to proceed?</p>
  </Modal>
);

const filterStorageKey = 'dealer-users-list-filters';

class DealerUserListPageComponent extends Component {
  constructor() {
    super();
    this.search = this.search.bind(this);
    this.handleBottomScroll = this.handleBottomScroll.bind(this);
    this.sendInvitationEmails = this.sendInvitationEmails.bind(this);
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    search: PropTypes.func.isRequired,
    simpleTable: PropTypes.bool.isRequired,
    downloadCsv: PropTypes.func.isRequired,
  };

  state = {
    items: [],
    filter: this.initializeFilter(),
    loading: true,
    hasLoadedAllPages: false,
    page: 0,
    showInvitationsModal: false,
    sendingInvitations: false,
    downloadingCsv: false,
    notInvitedUsersCount: null,
  };

  initializeFilter() {
    const saved = getGenericData(filterStorageKey);
    return saved ? new DealerUserFilter(saved) : new DealerUserFilter();
  }

  search() {
    saveGenericData(filterStorageKey, this.state.filter);
    this.loadPage(0);
  }

  async downloadCsv() {
    this.setState({ downloadingCsv: true });
    this.props.downloadCsv().then((blob) => {
      downloadWithFallback(blob, 'dealer-users.csv');
      this.setState({ downloadingCsv: false });
    });
  }

  handleBottomScroll() {
    if (!this.state.hasLoadedAllPages) {
      this.loadPage(this.state.page + 1);
    }
  }

  loadPage(page) {
    if (!this.state.loading) {
      this.setState({ loading: true, page });
    }
    this.props.search(this.state.filter, page).then((items) =>
      this.setState({
        items: page === 0 ? items : this.state.items.concat(items),
        loading: false,
        hasLoadedAllPages: items.length < pagination.pageSize,
      })
    );
  }

  async componentDidMount() {
    this.search();
  }

  handleOnOpenEdit = (dealerUserId) => {
    if (!dealerUserId) {
      throw Error('Cannot edit Dealer User. Invalid id specified.');
    }
    this.props.history.push(`/dealer-users/edit/${dealerUserId}`);
  };

  showSendInvitationsModal = async () => {
    this.setState({
      showInvitationsModal: true,
      notInvitedUsersCount: await dealerUserService.getNotInvitedCount(),
    });
  };

  sendInvitationEmails = async () => {
    this.setState({ sendingInvitations: true });
    dealerUserService.sendBulkInvitations().then(async () => {
      NotificationManager.success(
        'Invitation emails sent successfully',
        '',
        3 * 1000
      );
      this.setState({
        sendingInvitations: false,
        notInvitedUsersCount: await dealerUserService.getNotInvitedCount(),
      });
    });
  };

  render() {
    const {
      filter,
      items,
      loading,
      sendingInvitations,
      downloadingCsv,
      showInvitationsModal,
      notInvitedUsersCount,
    } = this.state;

    const { simpleTable } = this.props;

    return (
      <Fragment>
        <ListViewWrapper
          title="Dealer Users"
          buttons={
            <Fragment>
              <CreateButton
                onCreate={() => this.props.history.push('/dealer-users/new')}
              />
              <Button
                type="button"
                className="btn-primary ms-3 my-2"
                label={downloadingCsv ? 'Exporting' : 'Export CSV'}
                onClick={() => this.downloadCsv()}
                showSpinner={downloadingCsv}
                disabled={downloadingCsv}
                iconName="download"
              />
              {isAmiUserAuthorizedToSendBulkInvitations() && (
                <Button
                  type="button"
                  className="btn-primary ms-3 my-2"
                  label={
                    sendingInvitations ? 'Sending' : 'Send Bulk Invitations'
                  }
                  onClick={() => this.showSendInvitationsModal()}
                  showSpinner={sendingInvitations}
                  iconName="paper-plane"
                />
              )}
            </Fragment>
          }
        >
          <TableActions>
            <FilterComponent
              filter={filter}
              onChange={(x) =>
                this.setState({ filter: new DealerUserFilter(x) })
              }
              onFilter={() => this.search()}
            />
          </TableActions>
          {simpleTable && (
            <DealerUserSimpleTable
              onBottomScroll={this.handleBottomScroll}
              dealerUsers={items}
              onOpenEdit={this.handleOnOpenEdit}
              loading={loading}
            />
          )}
          {!simpleTable && (
            <Table
              onBottomScroll={this.handleBottomScroll}
              dealerUsers={items}
              onOpenEdit={this.handleOnOpenEdit}
              loading={loading}
            />
          )}
        </ListViewWrapper>
        {isAmiUserAuthorizedToSendBulkInvitations() && (
          <SendInvitationsConfirmationModal
            show={showInvitationsModal}
            onShowUpdated={(show) => {
              if (!show) this.setState({ showInvitationsModal: false });
            }}
            onConfirm={this.sendInvitationEmails}
            usersCount={notInvitedUsersCount}
          />
        )}
      </Fragment>
    );
  }
}

const DealerUserListPage = withRouter(DealerUserListPageComponent);
export { DealerUserListPage };
